import script from "./CreateExamView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateExamView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateExamView.vue?vue&type=style&index=0&id=243ae80e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243ae80e"]])

export default __exports__